import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from '../shared/local-storage.service';
import { Subscription } from 'rxjs';
import { GroundfishDelivery } from '../shared/groundfish-delivery.model';
import { HMSDelivery } from '../shared/hms-delivery.model';
import { TrawlDelivery } from '../shared/trawl-delivery.model';

/**
 * List of completed deliveries.
 * Small component to display the deliveries and navigate to them.
 */
@Component({
    selector: 'app-delivery-list',
    templateUrl: './delivery-list.component.html',
    styleUrls: ['./delivery-list.component.css'],
    standalone: false
})
export class DeliveryListComponent implements OnInit, OnDestroy {


  landings: (GroundfishDelivery | HMSDelivery | TrawlDelivery)[] = [];
  landingsSubscription!: Subscription;
  editedLogSubscription!: Subscription;
  editedLogbookId: string = '';
  user = LocalStorageService.current_user;


  constructor(public router: Router) { }

  ngOnInit(): void {
    LocalStorageService.storage_promise.then(_ => {
      if (this.user.trawlFishery) {
        this.landings = LocalStorageService.received_trawlLogbooks;
        this.editedLogbookId = LocalStorageService.edited_trawlLogbook.logbookId;
        this.landingsSubscription = LocalStorageService.received_trawlLogbooks$.subscribe(val => this.landings = val);
        this.editedLogSubscription = LocalStorageService.edited_trawlLogbook$.subscribe(val => this.editedLogbookId = val.logbookId);
      } else {
        this.landings = LocalStorageService.received_logbooks;
        this.editedLogbookId = LocalStorageService.edited_logbook.GF.logbookId ?? LocalStorageService.edited_logbook.HMS.logbookId;
        this.landingsSubscription = LocalStorageService.received_logbooks$.subscribe(val => this.landings = val);
        this.editedLogSubscription = LocalStorageService.edited_logbook$.subscribe(val => this.editedLogbookId = val.GF.logbookId ?? val.HMS.logbookId);
      }
    });
  }



  onLandingClick(index: number) {
    this.router.navigate([this.landings[index] instanceof GroundfishDelivery ? 'delivery_detail' :
      this.landings[index] instanceof TrawlDelivery ? 'trawl_delivery' :
        'hms_delivery_detail', this.landings[index].logbookId == this.editedLogbookId ? 2 : 1, index], { queryParams: { previous: 'deliveries_list' } });
    if ((document.documentElement.scrollTop || document.body.scrollTop) > 0) window.scrollTo(0, 0);
  }


  ngOnDestroy(): void {
    if (this.landingsSubscription) this.landingsSubscription.unsubscribe();
    if (this.editedLogSubscription) this.editedLogSubscription.unsubscribe();
  }

}
